// extracted by mini-css-extract-plugin
export default {"wrap":"TotalAcc_wrap__-VUMq","filter-btn":"TotalAcc_filter-btn__4vGsM","filter-btn-color":"TotalAcc_filter-btn-color__8PyYv","chart":"TotalAcc_chart__qysg6"};